import React, { useState, useEffect, useContext, useRef } from "react";
import { MaintenanceContext } from "context/maintenanceProvider";
import { useParams } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  Divider,
  Form,
  Header,
  Icon,
  Rating,
  Segment,
  Table,
} from "semantic-ui-react";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import "scss/screens/maintenancePending/pendingOrderDetail.scss";
import MaintenanceHandle from "components/maintenance/maintenanceHandle";
import LetterLoading from "components/loading/letterLoading";
import Swal from "sweetalert2";
import SignaturePad from "react-signature-canvas";
import MaintenanceAdd from "components/maintenance/maintenanceAdd";
import { DeviceContext } from "context/deviceProvider";
import { UserContext } from "context/userProvider";
import { END_POINT } from "context/endPoint";
import dataURLtoBlob from "blueimp-canvas-to-blob";
import { Document, Page } from 'react-pdf';
import ReactToPrint from "react-to-print";
import { render } from "react-dom";


export default function MaintenanceRecordDetail() {
    const [isLoading, setIsLoading] = useState(false);
    const [customerForm, setCustomerForm] = useState(false);
    const [maintenanceDetail, setMaintenanceDetail] = useState([]);
    const [deviceForm, setDeviceForm] = useState(null);
    const [riceMill, setRiceMill] = useState([]);
    const [longTail, setLongTail] = useState([]);
    const [agricuture, setAgricuture] = useState([]);
    const [maintenanceImage, setMaintenanceImage] = useState([]);
    const [reviewForm, setReviewForm] = useState({});
    const [imageURL, setImageURL] = useState(null);
    const [rejectPart, setRejectPart] = useState([{ partName: "", qty: 0 }]);
    const maintenances = useContext(MaintenanceContext);
    const devices = useContext(DeviceContext);
    const sigCanvas = useRef({});
    const { id } = useParams();
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const users = useContext(UserContext);
  
    useEffect(() => {
      setIsLoading(true);
      setMaintenanceData();
    }, []);
  
    const setMaintenanceData = async () => {
      await devices.getMasterParts({ model: "" });
      await maintenances.getMaintenance({ state: [] });
      let data = await maintenances.maintenanceList.filter(
        (order) => order.documentNo === id
      );
      setMaintenanceDetail(data.length > 0 ? data[0] : []);
      setReviewForm(data[0]?.reviewForm != null ? data[0]?.reviewForm : {});
      setDeviceForm(data[0]?.form != null ? data[0]?.form : null);
      setRejectPart(
        data[0]?.rejectPartList?.length > 0
          ? data[0]?.rejectPartList
          : [{ partName: "", qty: 0 }]
      );
      setMaintenanceImage(
        data[0]?.images?.process?.length > 0 ? data[0]?.images?.process : []
      );
      setIsLoading(false);
      console.log(maintenanceDetail);
    };
  
    const alertDialog = (title, text, icon) => {
      Swal.fire({
        title: title,
        text: text,
        icon: icon,
      });
    };
  
    // class Example extends React.Component {
    //   render() {
    //     return (
    //       <div>
    //         <ReactToPrint
    //           trigger={() => <a href="#"> <div align="center"> Save this PDF! </div></a>}
    //           content={() => this.componentRef}
    //         />
    //         <ComponentToPrint ref={el => (this.componentRef = el)} />
    //       </div>
    //     );
    //   }
    // }
    // render(<Example />, document.getElementById("root")); 
  
    // // ComponentToPrint.js
    // class ComponentToPrint extends React.Component {
    //   render() {
    //     return (
    //       <div >
    //     <h2>ประวัติการซ่อม</h2>     
    //     <div className="pendingOrderDetail-content-inform">
    //       {<MaintenanceAdd order={maintenanceDetail} />}
    //     </div>

    //     <div className="pendingOrderDetail-content-handle">
    //       {<MaintenanceHandle order={maintenanceDetail} />}
    //     </div>

    //     <div className="pendingOrderDetail-content-maintenance">
    //       <Divider horizontal>
    //         <Header as="h3">
    //           <Icon name="wrench" />
    //           ดำเนินการซ่อม
    //         </Header>
    //       </Divider>
    //       {createMaintenanceForm()}
    //     </div>
    //     </div>
    //     );
    //   }
    // }
  
    const onSelectImage = (e) => {
      console.log("e.target.files: " + e.target.files.length);
      if (maintenanceImage.length < 10 && e.target.files.length < 11) {
        let files = Array.from(e.target.files).map((image) => image);
        setMaintenanceImage([...maintenanceImage, ...files]);
      } else {
        alertDialog("Error!", "ไม่สามารถอัพโหลดรูปภาพได้เกิน 10 รูป", "error");
      }
    };
  
    const onGetMonth = (month) => {
      const monthNames = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ];
      return monthNames[parseInt(month) - 1];
    };
  
    const onUpdateTimeFormat = (date) => {
      let updateDate =
        date
          .toLocaleDateString("ko-KR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
          .replaceAll(". ", "-")
          .replaceAll(".", " ") + date.toTimeString().substring(0, 8);
      return updateDate;
    };
  
    const onUpdateMaintenance = async (button) => {
      if (button === "reject") {
        const data = { id: maintenanceDetail.id, isReturn: 1, state: "received" };
        const formData = new FormData();
        formData.append("data", JSON.stringify(data));
  
        let result = await maintenances.updateMaintenanceWithImage(formData);
        if (result?.code === 0) {
          return alertDialog("Success!", result?.description, "success");
        } else {
          return alertDialog("Error!", result?.description, "error");
        }
      }
      // if (
      //   maintenanceDetail?.handleNote == null ||
      //   maintenanceDetail?.handleDate == null ||
      //   maintenanceDetail?.provinceId == null
      // ) {
      //   return alertDialog("Error!", "กรุณากรอกข้อมูลให้ครบถ้วน", "error");
      // }
  
      const data = {
        confirmSerial: maintenanceDetail.confirmSerial,
        detectCause: maintenanceDetail.detectCause,
        maintenanceDate: maintenanceDetail?.beginMaintenanceDate,
        maintenanceNote: maintenanceDetail.maintenanceNote,
        id: maintenanceDetail.id,
        problemSolvingSolution: maintenanceDetail.problemSolvingSolution,
        rejectPartList: rejectPart,
        beginMaintenanceDate: maintenanceDetail.beginMaintenanceDate,
        endMaintenanceDate: maintenanceDetail.endMaintenanceDate,
        reviewForm: reviewForm,
        form: deviceForm,
        //   deviceType === "riceMill"
        //     ? riceMill
        //     : deviceType === "longTail"
        //     ? longTail
        //     : agricuture,
  
        state: button === "approve" ? "finish" : "process",
        isComplete: button === "approve" ? 1 : 0,
        isReturn: button === "reject" ? 1 : 0,
        workerId: "manager",
      };
  
      console.log(data);
      const formData = new FormData();
      maintenanceImage?.map((image) => formData.append("file", image));
  
      if (imageURL != null && !reviewForm?.signature) {
        formData.append("signatureImage", imageURL, "signature.png");
      }
      formData.append("data", JSON.stringify(data));
      console.log(formData);
  
      //! ----------- update maintenance -----------
      let result = await maintenances.updateMaintenanceWithImage(formData);
      if (result?.code === 0) {
        return alertDialog("Success!", result?.description, "success");
      } else {
        return alertDialog("Error!", result?.description, "error");
      }
    };

  const createMaintenanceForm = () => {
    return (
      <Segment>
        <table className="maintenance">
          <tbody>
            <tr>
              <td>
                วันที่ทำการแก้ไข <span>*</span>
              </td>
              <td>
                <Form>
                  <input
                    type="text"
                    placeholder="วันที่ทำการแก้ไข"
                    value={
                      (maintenanceDetail?.beginMaintenanceDate &&
                        `${maintenanceDetail?.beginMaintenanceDate.substring(
                          8,
                          10
                        )} ${onGetMonth(
                          maintenanceDetail?.beginMaintenanceDate.substring(
                            5,
                            7
                          )
                        )} ${
                          parseInt(
                            maintenanceDetail?.beginMaintenanceDate.substring(
                              0,
                              4
                            )
                          ) + 543
                        }`) ||
                      `${onUpdateTimeFormat(new Date()).substring(
                        8,
                        10
                      )} ${onGetMonth(
                        onUpdateTimeFormat(new Date()).substring(5, 7)
                      )} ${
                        parseInt(
                          onUpdateTimeFormat(new Date()).substring(0, 4)
                        ) + 543
                      }`
                    }
                    readOnly
                  />
                </Form>
              </td>
            </tr>
            <tr>
              <td>เวลาเริ่มซ่อม</td>
              <td>{maintenanceDetail?.beginMaintenanceDate || "-"}</td>
            </tr>
            <tr>
              <td>เวลาที่ซ่อมเสร็จ</td>
              <td>{maintenanceDetail?.endMaintenanceDate || "-"}</td>
            </tr>
            {(maintenanceDetail?.beginMaintenanceDate != null ||
              maintenanceDetail?.endMaintenanceDate != null) && (
              <tr>
                <td>เวลารวม</td>
                <td>
                  <Form>
                    <input
                      type="text"
                      placeholder="เวลารวม (วินาที)"
                      value={maintenanceDetail?.totalActivateSec}
                      readOnly
                    />
                  </Form>
                </td>
              </tr>
            )}
            <tr>
              <td>
                Serial เครื่อง <span>*</span>
              </td>
              <td>
                <Form>
                  <input
                    type="text"
                    placeholder="Serial เครื่อง"
                    value={maintenanceDetail?.confirmSerial}
                    onChange={(e) =>
                      setMaintenanceDetail({
                        ...maintenanceDetail,
                        confirmSerial: e.target.value,
                      })
                    }
                  />
                </Form>
              </td>
            </tr>
            <tr>
              <td>
                สาเหตุที่ตรวจพบ <span>*</span>
              </td>
              <td>
                <Form>
                  <input
                    type="text"
                    placeholder="สาเหตุที่ตรวจพบ"
                    value={maintenanceDetail?.detectCause}
                    onChange={(e) =>
                      setMaintenanceDetail({
                        ...maintenanceDetail,
                        detectCause: e.target.value,
                      })
                    }
                  />
                </Form>
              </td>
            </tr>
            <tr>
              <td>
                การดำเนินการซ่อม <span>*</span>
              </td>
              <td>
                <Form>
                  <input
                    type="text"
                    placeholder="การดำเนินการซ่อม"
                    value={maintenanceDetail?.problemSolvingSolution}
                    onChange={(e) =>
                      setMaintenanceDetail({
                        ...maintenanceDetail,
                        problemSolvingSolution: e.target.value,
                      })
                    }
                  />
                </Form>
              </td>
            </tr>
            <tr>
              <td>ผลลัพธ์หลังการ Setting</td>
              <td>{selectDeviceType()}</td>
            </tr>
            <tr>
              <td>อะไหล่ที่นำกลับ</td>
              <td>{getRejectPart()}</td>
            </tr>
            <tr>
              <td>หมายเหตุ</td>
              <td>
                <Form>
                  <Form.TextArea
                    placeholder="หมายเหตุ"
                    value={maintenanceDetail?.maintenanceNote || ""}
                    onChange={(e) =>
                      setMaintenanceDetail({
                        ...maintenanceDetail,
                        maintenanceNote: e.target.value,
                      })
                    }
                  />
                </Form>
              </td>
            </tr>
          </tbody>
        </table>

        {/* {createHandleImage()} */}
        {
          // maintenanceDetail?.reviewForm == null &&
          // createCustomerForm()
        }
      </Segment>
    );
  };

  const selectDeviceType = () => {
    return (
      <>
        <Form>
          <Form.Checkbox
            label="เครื่องสีข้าว เครื่องคัดแยกเมล็ดพันธุ์"
            value="riceMill"
            checked={deviceForm?.deviceType === "riceMill"}
            onChange={(e, { value }) => {
              setDeviceForm({
                ...deviceForm,
                deviceType: value,
              });
            }}
          />
          <Form.Checkbox
            label="เครื่องจักรกลทางการเกษตร"
            value="agricuture"
            checked={deviceForm?.deviceType === "agricuture"}
            onChange={(e, { value }) => {
              setDeviceForm({
                ...deviceForm,
                deviceType: value,
              });
            }}
          />
          <Form.Checkbox
            label="หางเรือ, อื่นๆ"
            value="longTail"
            checked={deviceForm?.deviceType === "longTail"}
            onChange={(e, { value }) =>
              setDeviceForm({
                ...deviceForm,
                deviceType: value,
              })
            }
          />
        </Form>
        {deviceForm?.deviceType === "riceMill" && riceMillDevice()}
        {deviceForm?.deviceType === "agricuture" && agricutureDevice()}
        {deviceForm?.deviceType === "longTail" && longTailDevice()}
      </>
    );
  };

  const createHandleImage = () => {
    return (
      <>
        <Divider horizontal>
          <Header as="h4">
            <Icon name="images" />
            การแก้ไข ({maintenanceImage.length}/10)
          </Header>
        </Divider>
        <div className="addMaintenance">
          {maintenanceImage.length > 0 &&
            maintenanceImage.map((image, idx) => (
              <div key={idx} className="fadein">
                <img
                  key={idx}
                  alt="add-maintenance"
                  src={`${END_POINT}/get/image?name=${image.path}`}
                  style={{
                    width: 300,
                    height: 300,
                    objectFit: "cover",
                  }}
                />
              </div>
            ))}
        </div>
      </>
    );
  };

  const createCustomerForm = () => {
    console.log(imageURL);
    return (
      <div className="customer">
        <Divider horizontal>
          <Header as="h4">
            <Icon name="paper plane" />
            การประเมินความพึงพอใจของลูกค้า
          </Header>
        </Divider>

        <div className="customer-form">
          <div className="rating">
            <div>
              <h4>ความพึงพอใจในการ SERVICE</h4>
              <Rating
                maxRating={5}
                defaultRating={reviewForm?.service}
                icon="star"
                size="massive"
                onRate={(e, { rating }) =>
                  setReviewForm({ ...reviewForm, service: rating })
                }
              />
            </div>
            <div>
              <h4>ความพึงพอใจเกี่ยวกับผลิตภัณฑ์</h4>
              <Rating
                maxRating={5}
                defaultRating={reviewForm?.device}
                icon="star"
                size="massive"
                onRate={(e, { rating }) =>
                  setReviewForm({ ...reviewForm, device: rating })
                }
              />
            </div>
            <div></div>
          </div>
          <div className="bottom">
            <div>
              <h4>ข้อเสนอแนะของลูกค้า</h4>
              <Form>
                <Form.TextArea
                  placeholder="ข้อเสนอแนะของลูกค้า"
                  value={reviewForm?.comment}
                  onChange={(e) =>
                    setReviewForm({ ...reviewForm, comment: e.target.value })
                  }
                />
              </Form>
            </div>
            <div>
              <h4>ลายเซ็นต์ของลูกค้า</h4>
              <>
                <div className="bottom-sign">
                  {reviewForm?.signature ? (
                    <>
                      <img
                        alt="add-maintenance"
                        src={`${END_POINT}/get/image?name=${reviewForm?.signature}`}
                        style={{
                          // width: 300,
                          // height: 300,
                          objectFit: "cover",
                        }}
                      />
                    </>
                  ) : (
                    <SignaturePad
                      ref={sigCanvas}
                      width={500}
                      canvasProps={{
                        className: "signatureCanvas",
                      }}
                    />
                  )}
                </div>
                {/* <div className="bottom-button">
                  {!maintenanceDetail?.reviewForm?.signature && (
                    <>
                      <Button
                        color="blue"
                        onClick={() => {
                          setImageURL(
                            dataURLtoBlob(
                              sigCanvas.current
                                .getTrimmedCanvas()
                                .toDataURL("image/png")
                            )
                          );
                          // console.log(imageURL);
                        }}
                      >
                        บันทึก
                      </Button>
                      <Button
                        color="grey"
                        onClick={() => sigCanvas.current.clear()}
                      >
                        ล้างค่า
                      </Button>
                      <Button
                        basic
                        color="red"
                        onClick={() => setCustomerForm(!customerForm)}
                      >
                        ยกเลิก
                      </Button>                                        
                    </>
                  )}
                </div> */}
              </>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const riceMillDevice = () => {
    return (
      <>
        <ul>
          <li>
            - กระแสไฟฟ้า{" "}
            <Form.Input
              type="number"
              placeholder="กระแสไฟฟ้า"
              value={deviceForm?.amp}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, amp: e.target.value })
              }
            />{" "}
            A
          </li>
          <li>
            - แรงดันไฟฟ้า{" "}
            <Form.Input
              type="number"
              placeholder="แรงดันไฟฟ้า"
              value={deviceForm?.voltage}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, voltage: e.target.value })
              }
            />{" "}
            V
          </li>
          <li>
            - ความเร็วรอบมอเตอร์{" "}
            <Form.Input
              type="number"
              placeholder="ความเร็วรอบมอเตอร์"
              value={deviceForm?.motorSpeed}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, motorSpeed: e.target.value })
              }
            />{" "}
            RPM
          </li>
          <li>
            - ความเร็วรอบกระเทาะ{" "}
            <Form.Input
              type="number"
              placeholder="ความเร็วรอบกระเทาะ"
              value={deviceForm?.crackerSpeed}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, crackerSpeed: e.target.value })
              }
            />{" "}
            RPM
          </li>
          <li>
            - ความเร็วรอบขัดขาว{" "}
            <Form.Input
              type="number"
              placeholder="ความเร็วรอบขัดขาว"
              value={deviceForm?.whitePolishingSpeed}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  whitePolishingSpeed: e.target.value,
                })
              }
            />{" "}
            RPM
          </li>
          <li>
            - ความเร็วรอบพัดลมแกลบ{" "}
            <Form.Input
              type="number"
              placeholder="ความเร็วรอบพัดลมแกลบ"
              value={deviceForm?.chaffFanSpeed}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, chaffFanSpeed: e.target.value })
              }
            />{" "}
            RPM
          </li>
          <li>
            - ความเร็วรอบพัดลมรำ{" "}
            <Form.Input
              type="number"
              placeholder="ความเร็วรอบพัดลมรำ"
              value={deviceForm?.brandFanSpeed}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, brandFanSpeed: e.target.value })
              }
            />{" "}
            RPM
          </li>
          <li>
            - สมรรถนะการสีข้าว{" "}
            <Form.Input
              type="number"
              placeholder="สมรรถนะการสีข้าว"
              value={deviceForm?.riceMillingPerformance}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  riceMillingPerformance: e.target.value,
                })
              }
            />{" "}
            กก.ข้าวเปลือก/ชม.
          </li>
          <li>
            - ข้าวดี{" "}
            <Form.Input
              type="number"
              placeholder="ข้าวดี"
              value={deviceForm?.goodRice}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  goodRice: e.target.value,
                })
              }
            />{" "}
            %
          </li>
          <li>
            - กากข้าว/ข้าวหัก{" "}
            <Form.Input
              type="number"
              placeholder="กากข้าว/ข้าวหัก"
              value={deviceForm?.brokenRice}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  brokenRice: e.target.value,
                })
              }
            />{" "}
            %
          </li>
        </ul>
      </>
    );
  };

  const longTailDevice = () => {
    return (
      <>
        <ul>
          <li>
            <Form>
              <Form.TextArea
                label="ข้อมูล Setting"
                placeholder="ข้อมูล Setting"
                value={deviceForm?.result}
                onChange={(e) =>
                  setDeviceForm({ ...deviceForm, result: e.target.value })
                }
              />
            </Form>
          </li>
          <li>
            <Form>
              <Form.TextArea
                label="สมรรถนะหลัง Setting"
                placeholder="สมรรถนะหลัง Setting"
                value={deviceForm?.summaryPerformance}
                onChange={(e) =>
                  setDeviceForm({
                    ...deviceForm,
                    summaryPerformance: e.target.value,
                  })
                }
              />
            </Form>
          </li>
        </ul>
      </>
    );
  };

  const agricutureDevice = () => {
    return (
      <>
        <ul>
          <li>
            <Form>
              <Form.TextArea
                label="ข้อมูล Setting"
                placeholder="ข้อมูล Setting"
                value={deviceForm?.result}
                onChange={(e) =>
                  setDeviceForm({ ...deviceForm, result: e.target.value })
                }
              />
            </Form>
          </li>
          <li>
            <Form>
              <Form.TextArea
                label="สมรรถนะหลัง Setting"
                placeholder="สมรรถนะหลัง Setting"
                value={deviceForm?.summaryPerformance}
                onChange={(e) =>
                  setDeviceForm({
                    ...deviceForm,
                    summaryPerformance: e.target.value,
                  })
                }
              />
            </Form>
          </li>
        </ul>
      </>
    );
  };

  const getRejectPart = () => {
    return (
      <>
        <Table celled className="rejectPart">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>ชื่ออะไหล่</Table.HeaderCell>
              <Table.HeaderCell>จำนวน</Table.HeaderCell>
              <Table.HeaderCell>สถานะ</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {rejectPart?.map((part, idx) => (
              <Table.Row key={idx}>
                <Table.Cell>
                  <Form>
                    <input
                      placeholder="ชื่ออะไหล่"
                      value={part?.partName || ""}
                      onChange={(e) => {
                        let newPartUse = rejectPart;
                        newPartUse[idx]["partName"] = e.target.value;
                        setRejectPart([...newPartUse]);
                      }}
                    />
                  </Form>
                </Table.Cell>
                <Table.Cell>
                  <Form>
                    <input
                      type="number"
                      placeholder="จำนวน"
                      value={part?.qty || ""}
                      onChange={(e) => {
                        let newPartUse = rejectPart;
                        newPartUse[idx]["qty"] = parseInt(e.target.value);
                        setRejectPart([...newPartUse]);
                      }}
                    />
                  </Form>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </>
    );
  };

  return (
    <div >
        <h2>ประวัติการซ่อม</h2>     
        <div className="pendingOrderDetail-content-inform">
          {<MaintenanceAdd order={maintenanceDetail} />}
        </div>

        <div className="pendingOrderDetail-content-handle">
          {<MaintenanceHandle order={maintenanceDetail} />}
        </div>

        {users.userDetail?.role !== "sc" &&( 
        <div className="pendingOrderDetail-content-maintenance">
          <Divider horizontal>
            <Header as="h3">
              <Icon name="wrench" />
              ดำเนินการซ่อม
            </Header>
          </Divider>
          {createMaintenanceForm()}
        </div>)}
    </div>
  );
}
   